import React from "react";
import { TableRow, TableCell } from "semantic-ui-react";

const recentNotesTableCell = props => {
  let noteStyle = { width: "450px", maxHeight: "35px", overflow: "hidden" };
  let expandContract = "expand_chevron";
  if (props.isExpanded) {
    noteStyle = { width: "450px" };
    expandContract = "contract_chevron";
  }
  var div = document.createElement("div");
  div.style.width = "450px";
  div.innerHTML = props.noteContent;
  div.style.visibility = "hidden";
  document.body.appendChild(div);
  const noteOverflow = div.offsetHeight > 35;
  document.body.removeChild(div);

  return (
    <TableRow className="note_row">
      <TableCell className="date_col">{props.noteCreatedDate}</TableCell>
      <TableCell className="note_col">
        <div style={noteStyle}>{props.noteContent}</div>
      </TableCell>
      <TableCell className="edit_del_col">
        {props.disabled ? (
          ""
        ) : (
          <a className="edit_note_icon" onClick={props.editNoteClicked}>
            {window.APP.LANGUAGE.Pages.CustomerNotes.Edit}
          </a>
        )}
        {props.disabled ? (
          ""
        ) : (
          <div className="del_icon" onClick={props.deleteNoteClicked} />
        )}
        <div
          className={expandContract}
          onClick={props.expandNoteClicked}
          hidden={!noteOverflow}
        />
      </TableCell>
    </TableRow>
  );
};

export default recentNotesTableCell;
